import { render, staticRenderFns } from "./DDiscardMappingChangesConfirmation.vue?vue&type=template&id=ceb708a2&scoped=true&"
import script from "./DDiscardMappingChangesConfirmation.vue?vue&type=script&lang=js&"
export * from "./DDiscardMappingChangesConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DDiscardMappingChangesConfirmation.vue?vue&type=style&index=0&id=ceb708a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb708a2",
  null
  
)

export default component.exports